/**
 * Request module constants and helper functions
 */
import { Badge } from '../ui/badge';
import { Clock, CheckCircle2, AlertCircle, XCircle } from 'lucide-react';

/**
 * Get status badge component for a payment request
 */
export const getStatusBadge = (status) => {
  switch (status) {
    case 'pending':
      return <Badge className="bg-amber-500/20 text-amber-600 border-0"><Clock className="w-3 h-3 mr-1" />Pending</Badge>;
    case 'completed':
      return <Badge className="bg-emerald-500/20 text-emerald-600 border-0"><CheckCircle2 className="w-3 h-3 mr-1" />Completed</Badge>;
    case 'expired':
      return <Badge className="bg-slate-500/20 text-slate-600 border-0"><AlertCircle className="w-3 h-3 mr-1" />Expired</Badge>;
    case 'cancelled':
      return <Badge className="bg-red-500/20 text-red-600 border-0"><XCircle className="w-3 h-3 mr-1" />Cancelled</Badge>;
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

/**
 * Format expiry date for display
 */
export const formatExpiry = (expiresAt) => {
  if (!expiresAt) return 'No expiry';
  const date = new Date(expiresAt);
  const now = new Date();
  const diff = date - now;
  
  if (diff < 0) return 'Expired';
  if (diff < 3600000) return `${Math.floor(diff / 60000)} min left`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)} hours left`;
  return date.toLocaleDateString();
};

/**
 * Expiry options for request creation
 */
export const EXPIRY_OPTIONS = [
  { value: '1', label: '1 hour' },
  { value: '6', label: '6 hours' },
  { value: '24', label: '24 hours' },
  { value: '72', label: '3 days' },
  { value: '168', label: '7 days' },
];
